import { Params } from '@angular/router';

export enum NavigationActionTypes {
    LoadAuthenticatedMenu = '[Navigation] Load authenticated menu',
    ClearMenu = '[Navigation] Clear menu',
    Navigate = '[Navigation] Navigate',
    RefreshMenu = '[Navigation] Refresh menu',
    GoBack = '[Navigation] Go back'
}

export class LoadAuthenticatedMenuAction {
    static readonly type = NavigationActionTypes.LoadAuthenticatedMenu;
}

export class ClearMenuAction {
    static readonly type = NavigationActionTypes.ClearMenu;
}

export class NavigateAction {
    static readonly type = NavigationActionTypes.Navigate;
    constructor(public url: string, public queryParams: Params, public isClubContext: boolean = true) {}
}

export class RefreshMenuAction {
    static readonly type = NavigationActionTypes.RefreshMenu;
}

export class GoBack {
    static readonly type = NavigationActionTypes.GoBack;
}
